export class ProfileContext {
    serialize() {
        return {};
    }
}
export class DeviceProfile {
    constructor(id, label, owner, connectivity, converterId, context, createTime) {
        this.id = id;
        this.label = label;
        this.owner = owner;
        this.connectivity = connectivity;
        this.converterId = converterId;
        this.context = context;
        this.createTime = createTime;
    }
}
export class NewDeviceProfile {
    constructor(id, label, connectivity, converterId, context) {
        this.id = id;
        this.label = label;
        this.connectivity = connectivity;
        this.converterId = converterId;
        this.context = context;
    }
}
//# sourceMappingURL=DeviceProfileManager.js.map